import { CardMedia, Typography, Box, useTheme, Tooltip, Avatar } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import VisibilityIcon from '@mui/icons-material/Visibility';

import { TrackgoodIconSmall } from 'src/assets/icons/v2/TrackgoodSmallIcon';
import { IPopularProductItem, IPublicProductItem } from 'src/types';

interface IProps {
  product: IPublicProductItem | IPopularProductItem;
}

export const ProductItem = ({ product }: IProps) => {
  const theme = useTheme();
  const isAIGenerated = product.ai_generated;

  const tooltipText = isAIGenerated ?
  `${product.name} AI Generated` :
  `${product.name} on Trackgood`;

  return (
    <Tooltip id="product-item__components-home-products-list__tooltip__l22" title={tooltipText}>
      <Box id="product-item__components-home-products-list__box__l23"
      component={RouterLink}
      to={`/${product.simple_id}`}
      aria-label={`View details of ${product.name} from ${product.account?.account_holder ?? 'brand'}`}
      sx={{
        display: 'block',
        textDecoration: 'none',
        color: 'inherit',
        '&:visited': { color: 'inherit' },
        '&:hover .card-inner': {
          transform: 'scale(1.02)',
          borderColor: isAIGenerated ? theme.palette.grey[500] : theme.palette.primary.main
        },
        outline: '0'
      }}>
        
        <Box id="product-item__components-home-products-list__box__l39"
        className="card-inner"
        sx={{
          boxSizing: 'border-box',
          padding: '8px',
          width: '100%',
          cursor: 'pointer',
          border: `2px solid ${theme.palette.grey[200]}`,
          borderRadius: '15px',

          // smooth + no flicker:
          transform: 'translateZ(0) scale(1)',
          willChange: 'transform, border-color',
          backfaceVisibility: 'hidden',
          transition: 'transform 0.3s ease, border 0.3s ease'
        }}>
          
          <Box id="product-item__components-home-products-list__box__l56" sx={{ position: 'relative', height: 'auto', boxSizing: 'border-box' }}>
            {isAIGenerated ?
            <Box id="product-item__components-home-products-list__box__l58"
            sx={{
              position: 'absolute',
              top: 2,
              right: -3,
              backgroundColor: 'rgba(255,255,255,0.7)',
              borderRadius: '50%',
              p: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              
                <AutoAwesomeIcon sx={{ width: 20, height: 20, color: theme.palette.grey[700] }} />
              </Box> :

            <Box id="product-item__components-home-products-list__box__l74"
            sx={{
              position: 'absolute',
              top: 0,
              right: -5,
              backgroundColor: 'rgba(255,255,255,0.7)',
              borderRadius: '50%',
              p: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              
                <TrackgoodIconSmall height="25px" width="25px" />
              </Box>
            }

            {product?.account?.image_small &&
            <Box id="product-item__components-home-products-list__box__l92"
            sx={{
              position: 'absolute',
              top: 0,
              left: -2,
              backgroundColor: 'rgba(255,255,255,0.7)',
              borderRadius: '50%',
              p: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              
                <Tooltip id="product-item__components-home-products-list__tooltip__l105" title={product.account?.account_holder ?? ''}>
                  <Avatar id="product-item__components-home-products-list__avatar__l106"
                alt={product.account?.account_holder}
                src={product.account.image_small}
                sx={{ width: 25, height: 25 }} />
                
                </Tooltip>
              </Box>
            }

            <CardMedia id="product-item__components-home-products-list__cardmedia__l115"
            component="img"
            image={product.image_small}
            alt={product.name}
            sx={{ objectFit: 'contain', height: 'auto', maxHeight: 100, width: '100%' }} />
            
          </Box>

          <Box id="product-item__components-home-products-list__box__l123"
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            gap: '6px',
            p: '8px 4px'
          }}>
            
            <Typography id="product-item__components-home-products-list__typography__l132" fontSize="12px" fontWeight={700}>
              {product.name}
            </Typography>
            <Typography id="product-item__components-home-products-list__typography__l135" fontSize="10px">{product.account?.account_holder}</Typography>
            {!!product?.gtin &&
            <Typography id="product-item__components-home-products-list__typography__l137" fontSize="10px" sx={{ color: theme.palette.grey[500] }}>
                {product.gtin}
              </Typography>
            }
            {'views' in product &&
            <Box id="product-item__components-home-products-list__box__l142"
            sx={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start',
              gap: '4px'
            }}>
              
                <VisibilityIcon sx={{ width: 18, height: 18, color: theme.palette.primary.main }} />
                <Typography id="product-item__components-home-products-list__typography__l152" fontSize="10px" color="text.secondary">
                  {product.views.toLocaleString()}
                </Typography>
              </Box>
            }
          </Box>
        </Box>
      </Box>
    </Tooltip>);

};